import Vue from "vue";
export const EventBus = new Vue();

// TO USE EVENT BUS, PREPEND "event-bus" TO YOUR EVENTS